<template>
  <div class="tt-history-dropdown">
    <div class="tt-history-dropdown__container ff-mont">
      <slot name="labels"></slot>
      <div class="tt-icon-button"
           :class="{ 'tt-icon-button--reversed' : isDropped }"
           @click="toggleDropdown">
        <img src="@/assets/icons-new/chevron_down.svg">
      </div>
    </div>

    <transition name="slide-down">
      <div class="tt-history-dropdown__content"
           v-if="isDropped">
        <slot name="content"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data: () => ({
    isDropped: false
  }),
  methods: {
    toggleDropdown() {
      this.isDropped = !this.isDropped;
    }
  }
}
</script>

<style lang="sass" scoped>
@import "src/assets/styles-new/typography"
@import "src/assets/styles-new/colors"
@import "src/assets/styles-new/vars"

.tt-history-dropdown
  width: 100%
  margin-bottom: 16px
  border-bottom: 1px solid $gray
  &__container
    display: grid
    grid-template-columns: 50px 1fr 80px 100px 100px 1fr 24px
    gap: 12px
    align-items: center
    font-weight: $fw-semibold
    padding-bottom: 12px
  &__content
    margin-top: 24px
    margin-bottom: 48px
  .tt-icon-button
    height: 24px
    &:hover
      filter: invert(59%) sepia(86%) saturate(419%) hue-rotate(135deg) brightness(89%) contrast(82%)
    &--reversed
      transform: rotate(180deg)


@media screen and (max-width: $mobile-width)
  .tt-history-dropdown
    &__container
      grid-template-columns: 50px 1fr 24px
</style>